/* section-collection.js - collection filter / sort interactions */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // ── Sort select ───────────────────────────────────────────────────────────

  const sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ── Desktop filter form (live, debounced) ─────────────────────────────────

  const filterForm = $('[data-filter-form]');
  let filterTimer;

  function submitFilterForm() {
    if (!filterForm) return;
    const url = new URL(window.location.href);
    const fd  = new FormData(filterForm);

    // remove all filter params first (keep sort_by, page)
    const keep = ['sort_by', 'page'];
    for (const key of [...url.searchParams.keys()]) {
      if (!keep.includes(key)) url.searchParams.delete(key);
    }
    url.searchParams.delete('page');

    for (const [key, value] of fd.entries()) {
      if (value !== '') url.searchParams.append(key, value);
    }

    window.location.href = url.toString();
  }

  // Checkboxes use form= attribute association so change events bubble through
  // their own DOM parents, not through the form element. Listen on document.
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-filter-checkbox]')) return;
    clearTimeout(filterTimer);
    filterTimer = setTimeout(submitFilterForm, 400);
  });

  // ── Price range inputs → sync hidden inputs → debounced submit ────────────

  const priceMinInput = $('[data-price-min]');
  const priceMaxInput = $('[data-price-max]');
  const priceMinHidden = $('[data-price-min-hidden]');
  const priceMaxHidden = $('[data-price-max-hidden]');

  function syncAndSubmitPrice() {
    if (priceMinHidden && priceMinInput) priceMinHidden.value = priceMinInput.value;
    if (priceMaxHidden && priceMaxInput) priceMaxHidden.value = priceMaxInput.value;
    clearTimeout(filterTimer);
    filterTimer = setTimeout(submitFilterForm, 600);
  }

  if (priceMinInput) priceMinInput.addEventListener('change', syncAndSubmitPrice);
  if (priceMaxInput) priceMaxInput.addEventListener('change', syncAndSubmitPrice);

  // ── Filter group chevron toggle ───────────────────────────────────────────

  $$('[data-filter-group]').forEach(details => {
    details.addEventListener('toggle', () => {
      const chevron = details.querySelector('.coll-filter-group__chevron');
      if (chevron) chevron.classList.toggle('is-open', details.open);
    });
  });

  // ── Mobile drawer ─────────────────────────────────────────────────────────

  const drawer       = $('[data-filter-drawer]');
  const openBtns     = $$('[data-filter-drawer-open]');
  const closeBtns    = $$('[data-filter-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const firstFocus = $('button, [href], input, select', drawer);
    if (firstFocus) firstFocus.focus();
    openBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
  }

  openBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  closeBtns.forEach(btn => btn.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer && !drawer.hasAttribute('inert')) closeDrawer();
  });

  // ── Mobile filter form submit ─────────────────────────────────────────────

  const mobileForm = $('[data-filter-form-mobile]');
  if (mobileForm) {
    mobileForm.addEventListener('submit', e => {
      e.preventDefault();
      closeDrawer();
      const url = new URL(mobileForm.action);
      url.search = '';
      const fd = new FormData(mobileForm);
      for (const [key, value] of fd.entries()) {
        if (value !== '') url.searchParams.append(key, value);
      }
      window.location.href = url.toString();
    });
  }

  // ── Product card cascade entrance ─────────────────────────────────────────

  if ('IntersectionObserver' in window) {
    const cardObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        entry.target.classList.add('is-visible');
      });
    }, { threshold: 0.08 });

    // Stitch-wipe stagger: 40ms per card, capped so late cards don't lag.
    $$('.product-card').forEach((card, i) => {
      card.style.transitionDelay = `${Math.min(i, 16) * 40}ms`;
      cardObserver.observe(card);
    });
  } else {
    $$('.product-card').forEach(card => card.classList.add('is-visible'));
  }

})();
